import React from 'react';
import { TranslationsSystem } from '../0-TranslationsSystem';

export const TranslateContext =
    React.createContext/* <- TODO: Import and use just a createContext */ <TranslationsSystem>(null as any);
